import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

const text = 'Welcome to my portfolio';

const EntryAnimation = () => {
  const reduceMotion = useReducedMotion();
  const [displayedText, setDisplayedText] = useState('');
  const [phase, setPhase] = useState('typing');

  useEffect(() => {
    if (reduceMotion) return undefined;

    let index = 0;
    setDisplayedText('');
    setPhase('typing');
    const interval = setInterval(() => {
      index += 1;
      setDisplayedText(text.slice(0, index));
      if (index >= text.length) clearInterval(interval);
    }, 60);
    const completeTimer = setTimeout(() => setPhase('complete'), text.length * 60 + 550);

    return () => {
      clearInterval(interval);
      clearTimeout(completeTimer);
    };
  }, [reduceMotion]);

  return (
    <Box
      sx={{
        // Reserve space so the hero never shifts as the text changes.
        height: { xs: 72, sm: 64 },
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <Typography
        component="p"
        aria-label="Welcome to my portfolio"
        sx={{
          color: '#00e5ff',
          textShadow: '0 0 20px rgba(0, 229, 255, 0.5)',
          fontWeight: 800,
          fontFamily: "'Outfit', sans-serif",
          letterSpacing: '0.05em',
          fontSize: { xs: '1.1rem', sm: '1.75rem', md: '2rem' },
          lineHeight: 1.3,
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          {reduceMotion || phase === 'complete' ? (
            <motion.span
              key="portfolio"
              aria-hidden="true"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, ease: 'easeOut' }}
            >
              Portfolio
            </motion.span>
          ) : (
            <motion.span
              key="welcome"
              aria-hidden="true"
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.25, ease: 'easeIn' }}
            >
              {displayedText}
              <motion.span
                animate={{ opacity: [0, 1, 0] }}
                transition={{ repeat: Infinity, duration: 0.8 }}
                style={{ display: 'inline-block', width: 3, height: '1em', backgroundColor: '#00e5ff', marginLeft: 5, verticalAlign: 'middle' }}
              />
            </motion.span>
          )}
        </AnimatePresence>
      </Typography>
    </Box>
  );
};

export default EntryAnimation;
